var _mask, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEmbedInteractive = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "embed_interactive_svg__a",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  x: 1,
  y: 3,
  rx: 1
}))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 14,
  height: 10,
  x: 1,
  y: 3,
  stroke: "currentcolor",
  strokeWidth: 3,
  mask: "url(#embed_interactive_svg__a)",
  rx: 1
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentcolor",
  d: "M4.22 6.72A.75.75 0 0 0 4.75 8h.75v.75a.75.75 0 0 0 1.5 0V8h.75a.75.75 0 0 0 0-1.5H7v-.75a.75.75 0 0 0-1.5 0v.75h-.75a.75.75 0 0 0-.53.22ZM11.78 9.78a.75.75 0 0 0-.53-1.28H11v-.25a.75.75 0 1 0-1.5 0v.25h-.25a.75.75 0 0 0 0 1.5h.25v.25a.75.75 0 1 0 1.5 0V10h.25a.75.75 0 0 0 .53-.22Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgEmbedInteractive);
export default ForwardRef;